import { MenuItemTypes } from "@/app/(site)/_mockdata/menuItems"
import Menu from "../../Menu/Menu"
import { DropdownVisibilityState } from ".."
import { useEffect, useRef } from "react"

interface DropDownMenuProps {
    menuItems: MenuItemTypes[]
    showDropDownMenu: boolean
    setDropdownVisibility: (dropdownVisibility: DropdownVisibilityState) => void
}

declare module "react" {
    interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
        inert?: string // Add inert to HTML attributes
    }
}

const DropDownMenu = ({
    menuItems,
    showDropDownMenu,
    setDropdownVisibility
}: DropDownMenuProps) => {
    // This is for accessibility
    // Focus on first menu item when dropdown is opened
    useEffect(() => {
        if (showDropDownMenu) {
            const firstMenuItem = document.querySelector(
                'ul[role="menu"] li[role="menuitem"]'
            ) as HTMLElement
            firstMenuItem?.focus()
        }
        if (!showDropDownMenu && document.activeElement) {
            const dropdown = dropdownRef.current
            if (dropdown?.contains(document.activeElement)) {
                ;(document.activeElement as HTMLElement).blur()
            }
        }
    }, [showDropDownMenu])

    const dropdownRef = useRef<HTMLUListElement | null>(null)

    return (
        <>
            {menuItems && menuItems.length > 0 && (
                <ul
                    role="menu"
                    ref={dropdownRef}
                    id="dropdown-menu"
                    inert={!showDropDownMenu ? "true" : undefined} // 'inert' makes an element and its children non-interactive and unfocusable.
                    aria-hidden={!showDropDownMenu}
                    className={`absolute left-0 right-0 top-50 grid w-[100%] grid-cols-6 bg-white p-24 md:grid-cols-6 ${showDropDownMenu ? "visible z-20 opacity-100" : "pointer-events-none invisible -z-20 opacity-0"}`}
                >
                    {/* Just to get the space from top */}
                    <li role="presentation" className="col-span-6 mt-42"></li>
                    {menuItems.map((item, index) => {
                        return (
                            <li
                                key={index}
                                role="menuitem"
                                className="col-span-1 mb-24"
                                tabIndex={!showDropDownMenu ? -1 : 0}
                            >
                                <Menu
                                    setDropdownVisibility={setDropdownVisibility}
                                    items={[item]}
                                    level={1}
                                    replaceHistory={true}
                                />
                            </li>
                        )
                    })}
                </ul>
            )}
        </>
    )
}

export default DropDownMenu
